import React from 'react';
import PropTypes from 'prop-types';
import DeviceTemplate from './DeviceTemplate';

class Device extends React.Component {
	render() {
		const { form, search, device, disabled, onChange, required, displayInfo, displayLeasedWarning, isGroup } =
			this.props;
		return (
			<DeviceTemplate
				form={form}
				search={search}
				device={device}
				disabled={disabled}
				onChange={onChange}
				required={required}
				displayInfo={displayInfo}
				displayLeasedWarning={displayLeasedWarning}
				isGroup={isGroup}
			/>
		);
	}
}

Device.defaultProps = {
	device: {},
	disabled: false,
	required: true,
	displayInfo: true,
	isGroup: false,
	displayLeasedWarning: false,
};

Device.propTypes = {
	form: PropTypes.object.isRequired,
	search: PropTypes.func.isRequired,
	device: PropTypes.object,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	required: PropTypes.bool,
	isGroup: PropTypes.bool,
	displayInfo: PropTypes.bool.isRequired,
	displayLeasedWarning: PropTypes.bool.isRequired,
};

export default Device;
